;(function ($) {
    'use strict';
    $(document).ready(function () {

        $(document).on('submit', '#feedback_form', function (e) {
            e.preventDefault();
            const submitButton = document.querySelector('#feedback_form button[type=submit]');
            const form = this;

            submitButton.disabled = true;

            $.post({
                url: '/api/forms/feedback',
                dataType: 'json',
                contentType: 'application/json',
                data: JSON.stringify(
                    objectifyForm(
                        $('#feedback_form').serializeArray()
                    )
                ),

                success: (response) => {
                    // replace form with success message..
                    submitButton.disabled = false;
                    if (response.message) {
                        form.querySelector('.feedback-body').innerHTML = `<div class="feedback-block"><h2 class="notice">${response.message}</h2></div>`;
                    }
                },

                error: e => {
                    handleError(e);
                    submitButton.disabled = false;
                }
            });
        });


        $('#request_quote_form input[type=file]').on('change', function () {
            this.parentElement.querySelector('.quote-file-name').innerHTML = this.files[0].name;
        });

        $(document).on('submit', '#request_quote_form', function (e) {
            e.preventDefault();
            const submitButton = document.querySelector('#request_quote_form button[type=submit]');
            const form = this;

            submitButton.disabled = true;

            const formData = new FormData(form);

            $.post({
                url: '/api/forms/request-quote',
                dataType: 'json',
                data: formData,
                cache: false,
                contentType: false,
                processData: false,
                success: (response) => {
                    // replace form with success message..
                    submitButton.disabled = false;
                    if (response.message) {
                        form.innerHTML = `<div class="request-form-block"><h2 class="notice">${response.message}</h2></div>`;
                    }
                },

                error: e => {
                    console.log(e);
                    handleError(e);
                    submitButton.disabled = false;
                }
            });
        });


        $(document).on('submit', '#login_form', function (e) {
            e.preventDefault();
            const submitButton = document.querySelector('#login_form button[type=submit]');
            const form = this;

            submitButton.disabled = true;

            $.post({
                url: '/api/forms/login',
                dataType: 'json',
                contentType: 'application/json',
                data: JSON.stringify(
                    objectifyForm(
                        $('#login_form').serializeArray()
                    )
                ),

                success: (response) => {
                    submitButton.disabled = false;
                    if (response.message) {
                        const urlParams = new URLSearchParams(window.location.search);
                        const params = Object.fromEntries(urlParams.entries());

                        if (params.redirect) {
                            window.location = '/' + params.redirect;
                        } else {
                            window.location = '/graphimator'
                        }
                    }
                },

                error: e => {
                    handleError(e);
                    submitButton.disabled = false;
                }
            });
        });


        $(document).on('submit', '#register_form', function (e) {
            e.preventDefault();
            const submitButton = document.querySelector('#register_form button[type=submit]');

            submitButton.disabled = true;

            $.post({
                url: '/api/forms/register',
                dataType: 'json',
                contentType: 'application/json',
                data: JSON.stringify(
                    objectifyForm(
                        $('#register_form').serializeArray()
                    )
                ),

                success: (response) => {
                    submitButton.disabled = false;
                    if (response.message) {
                        gtag_report_registration_conversion();

                        const urlParams = new URLSearchParams(window.location.search);
                        const params = Object.fromEntries(urlParams.entries());

                        if (params.redirect) {
                            window.location = '/' + params.redirect;
                        } else {
                            window.location = '/graphimator'
                        }
                    }
                },

                error: e => {
                    handleError(e);
                    submitButton.disabled = false;
                }
            });
        });


        $(document).on('submit', '#forgot_password_form', function (e) {
            e.preventDefault();
            const submitButton = document.querySelector('#forgot_password_form button[type=submit]');
            const form = this;

            submitButton.disabled = true;

            $.post({
                url: '/api/forms/forgot-password',
                dataType: 'json',
                contentType: 'application/json',
                data: JSON.stringify(
                    objectifyForm(
                        $('#forgot_password_form').serializeArray()
                    )
                ),

                success: (response) => {
                    submitButton.disabled = false;
                    if (response.message) {
                        $(form).find('.label-text').text(response.message);

                        $(form).find('input').remove();

                        $(submitButton).replaceWith('<a href="/login" class="profile-action-button">Login</a>');
                    }
                },

                error: e => {
                    handleError(e);
                    submitButton.disabled = false;
                }
            });
        });


        $(document).on('submit', '#reset_password_form', function (e) {
            e.preventDefault();
            const submitButton = document.querySelector('#reset_password_form button[type=submit]');
            const form = this;

            submitButton.disabled = true;

            $.post({
                url: '/api/forms/reset-password',
                dataType: 'json',
                contentType: 'application/json',
                data: JSON.stringify(
                    objectifyForm(
                        $('#reset_password_form').serializeArray()
                    )
                ),

                success: (response) => {
                    submitButton.disabled = false;
                    if (response.message) {
                        $(form).find('.profile-input-rectangle')[1].remove();
                        $(form).find('.label-text').text(response.message);

                        $(form).find('input').remove();

                        $(submitButton).replaceWith('<a href="/login" class="profile-action-button">Login</a>');
                    }
                },

                error: e => {
                    handleError(e);
                    submitButton.disabled = false;
                }
            });
        });

        $(document).on('submit', '#personal_information_form', function (e) {
            e.preventDefault();
            const submitButton = document.querySelector('#personal_information_form button[type=submit]');
            const form = this;

            submitButton.disabled = true;

            $.post({
                url: '/api/forms/update-personal-information',
                dataType: 'json',
                contentType: 'application/json',
                data: JSON.stringify(
                    objectifyForm(
                        $('#personal_information_form').serializeArray()
                    )
                ),

                success: (response) => {
                    submitButton.disabled = false;
                    if (response.message) {
                        $('.success-message').text(response.message)
                    }
                },

                error: e => {
                    handleError(e);
                    submitButton.disabled = false;
                }
            });
        });


        $(document).on('submit', '#login_information_form', function (e) {
            e.preventDefault();
            const submitButton = document.querySelector('#login_information_form button[type=submit]');
            const form = this;

            submitButton.disabled = true;

            $.post({
                url: '/api/forms/update-login-information',
                dataType: 'json',
                contentType: 'application/json',
                data: JSON.stringify(
                    objectifyForm(
                        $('#login_information_form').serializeArray()
                    )
                ),

                success: (response) => {
                    submitButton.disabled = false;
                    if (response.message) {
                        $('.success-message').text(response.message)
                    }
                },

                error: e => {
                    handleError(e);
                    submitButton.disabled = false;
                }
            });
        });


        $(document).on('submit', '#update_address_information', function (e) {
            e.preventDefault();
            const submitButton = document.querySelector('#update_address_information button[type=submit]');
            const form = this;

            submitButton.disabled = true;

            $.post({
                url: '/api/forms/update-address-information',
                dataType: 'json',
                contentType: 'application/json',
                data: JSON.stringify(
                    objectifyForm(
                        $('#update_address_information').serializeArray()
                    )
                ),

                success: (response) => {
                    submitButton.disabled = false;
                    if (response.message) {
                        $('.success-message').text(response.message)
                    }
                },

                error: e => {
                    handleError(e);
                    submitButton.disabled = false;
                }
            });
        });

        $(document).on('click', '#proceed_to_payment', function () {
            const formData = objectifyForm(
                $('#shipping_address_form').serializeArray()
            );
            console.log(formData);

            $.post({
                url: '/api/forms/update-address-information',
                dataType: 'json',
                contentType: 'application/json',
                data: JSON.stringify(
                    objectifyForm(
                        $('#shipping_address_form').serializeArray()
                    )
                ),

                success: (response) => {

                }
            });
        });

        $(document).on('submit', '#shipping_address_form', function (e) {
            e.preventDefault();
            const submitButton = document.querySelector('#shipping_address_form button[type=submit]');
            const form = this;
            const form_data = objectifyForm( $('#shipping_address_form').serializeArray() );
            const count = $('.company-shipping-address').length;

            submitButton.disabled = true;

            $.post({
                url:         '/api/forms/update-address-information',
                dataType:    'json',
                contentType: 'application/json',
                data:        JSON.stringify(
                    objectifyForm(
                        $('#shipping_address_form').serializeArray()
                    )
                ),

                success: (response) => {
                    if (form_data.confirm_details) {
                        return window.location.reload();
                    }

                    submitButton.disabled = false;
                    if (response.message) {
                        $('.success-message').text(response.message)
                        if($('.profile-action-button').hasClass('hidden')) {
                            $('.profile-action-button').removeClass('hidden');
                        }
                    }

                    var country_name = response.country_name;
                    const state_name = response.state_name;
                    if (response.result_type == 'added') {
                        $('.shipping-information-container').append(`
                            <div class="shipping-information company-shipping-address ${count == 0 ? 'default-shipping-address' : ''}" id="shipping-address-${response.contact_id}">
                                <div class="shipping-information-body">
                                    <div class="shipping-information-header">
                                        <div class="shipping-label">
                                            <div class="label-text">
                                                ${count == 0 ? 'Default Shipping Address' : 'Alt Shipping Address #' + count}
                                            </div>
                                            <div class="label-shadow">
                                            </div>
                                        </div>
                                        <button class="edit-address" data-number="${count}" data-id="${response.address_id}" data-contact_id="${response.contact_id}"
                                        data-contact="${form_data['contact']}" data-company_title="${form_data['company_title']}" 
                                        data-address_1="${form_data['address_street_1']}" data-address_2="${form_data['address_street_2']}"
                                        data-country_id="${form_data['country_id']}" data-country_name="${country_name}" 
                                        data-state_id="${form_data['state_id']}" data-state_name="${state_name}"
                                        data-city="${form_data['city']}" data-zip="${form_data['zip']}" data-company_address_id="${response.company_address_id}"
                                        >Edit</button>
                                        <button class="remove-address" data-company_address_id="${response.company_address_id}" data-contact_id="${response.contact_id}">Remove
                                        </button>
                                    </div>
                                    <li>${form_data['contact']}</li>
                                    <li>${form_data['company_title']}</li>
                                    <li>${form_data['address_street_1']}</li>
                                    <li>${form_data['address_street_2']}</li>
                                    <li>${country_name}</li>
                                    <li>${state_name}</li>
                                    <li>${form_data['city']}</li>
                                    <li>${form_data['zip']}</li>
                                </div>
                            </div>
                        `);
                    } else if(response.result_type == 'updated') {
                        $("#shipping-address-" + response.contact_id).replaceWith(`
                            <div class="shipping-information company-shipping-address ${count == 0 || form_data['number'] == 0 ? 'default-shipping-address' : ''}" id="shipping-address-${response.contact_id}">
                                <div class="shipping-information-body">
                                    <div class="shipping-information-header">
                                        <div class="shipping-label">
                                            <div class="label-text">
                                                ${count == 0 || form_data['number'] == 0 ? 'Default Shipping Address' : 'Alt Shipping Address #' + form_data['number']}
                                            </div>
                                            <div class="label-shadow">
                                            </div>
                                        </div>
                                        <button class="edit-address" data-number="${form_data['number']}" data-id="${form_data['address_id']}" data-contact_id="${response.contact_id}"
                                        data-contact="${form_data['contact']}" data-company_title="${form_data['company_title']}" 
                                        data-address_1="${form_data['address_street_1']}" data-address_2="${form_data['address_street_2']}"
                                        data-country_id="${form_data['country_id']}" data-country_name="${country_name}" 
                                        data-state_id="${form_data['state_id']}" data-state_name="${state_name}" 
                                        data-city="${form_data['city']}" data-zip="${form_data['zip']}" data-company_address_id="${form_data['company_address_id']}"
                                        >Edit</button>
                                        <button class="remove-address" data-company_address_id="${form_data['company_address_id']}" data-contact_id="${response.contact_id}">Remove
                                        </button>
                                    </div>
                                    <li>${form_data['contact']}</li>
                                    <li>${form_data['company_title']}</li>
                                    <li>${form_data['address_street_1']}</li>
                                    <li>${form_data['address_street_2']}</li>
                                    <li>${country_name}</li>
                                    <li>${state_name}</li>
                                    <li>${form_data['city']}</li>
                                    <li>${form_data['zip']}</li>
                                </div>
                            </div>
                        `);
                    }
                    $("#shippingModal").css('display', 'none');
                    $("#body").toggleClass('modal-open');
                    $(this)[0].reset();
                    $("#address_type").val('shipping');

                },

                error: e => {
                    handleError(e);
                    submitButton.disabled = false;
                }
            });
        });
        
        $(document).on('change', '#edit-default-address-select', function () {
            const selected = $(this).find(':selected');
            
            $("#shipping_address_form input[name='contact']").val(selected.data('contact'));
            $("#shipping_address_form input[name='company_title']").val(selected.data('company_title'));
            $("#shipping_address_form input[name='address_street_1']").val(selected.data('address_1'));
            $("#shipping_address_form input[name='address_street_2']").val(selected.data('address_2'));
            $("#shipping_address_form select[name='country_id']").val(selected.data('country_id'));
            $("#shipping_address_form select[name='state_id']").val(selected.data('state_id'));
            $("#shipping_address_form input[name='city']").val(selected.data('city'));
            $("#shipping_address_form input[name='zip']").val(selected.data('zip'));
            
            $("#shipping_address_form input[name='contact_id']").val(selected.data('contact_id'));
            $("#shipping_address_form input[name='company_address_id']").val(selected.data('company_address_id'));
            $("#shipping_address_form input[name='address_id']").val(selected.data('address_id'));
        });

        $(document).on('submit', '#billing_address_form', function (e) {
            e.preventDefault();
            const submitButton = document.querySelector('#billing_address_form button[type=submit]');

            submitButton.disabled = true;

            $.post({
                url:         '/api/forms/update-address-information',
                dataType:    'json',
                contentType: 'application/json',
                data:        JSON.stringify(
                    objectifyForm(
                        $('#billing_address_form').serializeArray()
                    )
                ),
                success: (response) => {
                    window.location.reload();
                },

                error: e => {
                    handleError(e);
                    submitButton.disabled = false;
                }
            });
        });

        $(document).on('click', '.remove-address', function (e) {
            e.preventDefault();

            const confirmed = confirm("Are you sure you want to remove this address?");

            if(confirmed) {
                $.post({
                    url: '/api/forms/delete-shipping-address',
                    dataType: 'json',
                    contentType: 'application/json',
                    data: JSON.stringify({
                        contact_id: $(this).data('contact_id'),
                        company_address_id: $(this).data('company_address_id')
                    }),

                    success: (response) => {
                        if (response.message) {
                            $('.success-message').text(response.message)
                        }
                        $('#shipping-address-'+$(this).data('contact_id')).remove();
                    },

                    error: e => {
                        handleError(e);
                    }
                });
            }
        });

        let defaultShippingAddress;
        $('input[name=same_billing_shipping]').on('change', function() {
            let billingInputs;
            if (!defaultShippingAddress) {
                defaultShippingAddress = $('.shipping-address input').clone();
            }

            if (this.checked) {
                billingInputs = $('.billing-address input');
            } else {
                billingInputs = defaultShippingAddress;
            }

            for (const shippingInput of $('.shipping-address input')) {
                for (const billingInput of billingInputs) {
                    if (
                        shippingInput.name.replace('shipping') === billingInput.name.replace('billing')
                        || shippingInput.name === billingInput.name
                    ) {
                        $(shippingInput).val(billingInput.value)

                        break;
                    }
                }
            }

            for (const billingInput of billingInputs) {
                switch (billingInput.name) {
                    case 'billing_contact_first_name':
                        $("#shipping_address_form input[name='contact']").val(billingInput.value);
                        break;
                    case 'billing_address_street_1':
                        $("#shipping_address_form input[name='address_street_1']").val(billingInput.value);
                        break;
                    case 'billing_address_street_2':
                        $("#shipping_address_form input[name='address_street_2']").val(billingInput.value);
                        break;
                    case 'billing_country_name':
                        $("#shipping_address_form select[name='country_id']").val($('#billing_address_form select[name="country_id"] option:selected').val());
                        break;
                    case 'billing_state_code':
                        $("#shipping_address_form select[name='state_id']").val($('#billing_address_form select[name="state_id"] option:selected').val());
                        break;
                    case 'billing_address_city':
                        $("#shipping_address_form input[name='city']").val(billingInput.value);
                        break;
                    case 'billing_address_zip':
                        $("#shipping_address_form input[name='zip']").val(billingInput.value);
                        break;
                }
            }
        });



        $(document).on('submit', '#credit_application_form', function (e) {
            e.preventDefault();
            const submitButton = document.querySelector('#credit_application_form button[type=submit]');
            const form = this;

            submitButton.disabled = true;

            $.post({
                url: '/api/forms/apply-for-credit',
                dataType: 'json',
                contentType: 'application/json',
                data: JSON.stringify(
                    objectifyForm(
                        $('#credit_application_form').serializeArray()
                    )
                ),

                success: (response) => {
                    // replace form with success message..
                    submitButton.disabled = false;
                    if (response.message) {
                        form.querySelector('.feedback-body').innerHTML = `<div class="feedback-block"><h2 class="notice">${response.message}</h2></div>`;

                        location.hash = '#tab_container';
                    }
                },

                error: e => {
                    handleError(e);
                    submitButton.disabled = false;
                }
            });
        });

        $(document).on('change', '#template_file_upload', function (e) {
            const uploadButton = $('.ez-template-upload');
            if (this.value !== '') {
                uploadButton.removeAttr('disabled');

                const file = $('#template_file_upload').val().replace("C:\\fakepath\\", "");
                const fileName = $('.file-name');
                if (!fileName.length) {
                    uploadButton.after(`<p class="file-name">${file}</p>`);
                } else {
                    fileName.text(file);
                }
            } else {
                uploadButton.attr('disabled', true);
            }
        });

        $(document).on('click', '.ez-template-upload', function (e) {
            const fileInput = $('#template_file_upload');
            const form = $('#bulk_upload_form');

            fileInput.appendTo(form);

            form.submit();
        });
        
        function setStatesDropdownOptions(countryId) {
            const options = $('.profile-state-select option');
            options.prop('style', 'display:none;');

            const countryOptions = $(`.profile-state-select option[data-country="${countryId}"]`);
            countryOptions.prop('style', '');
        }
        
        const selectedBillingCountry = $('.edit-billing-address').data('country_id');
        if (selectedBillingCountry) {
            setStatesDropdownOptions(selectedBillingCountry);
        } else {
            // default to usa
            setStatesDropdownOptions(236);
        }
        
        function setShippingStateOptions(countryId) {
            const options = $('#shipping_state_select option');
            options.prop('style', 'display:none;');

            const countryOptions = $(`#shipping_state_select option[data-country="${countryId}"]`);
            countryOptions.prop('style', '');
        }
        
        const selectedShippingCountry = $('.shipping-information-header .edit-address').data('country_id');
        if (selectedShippingCountry) {
            setShippingStateOptions(selectedShippingCountry)
        } else {
            setShippingStateOptions(236);
        }

        $(document).on('change', '#profile_country_select', function () {
            setStatesDropdownOptions(this.value);
        });

        $(document).on('change', '#shipping_country_select', function () {
            setShippingStateOptions(this.value);
        });
    });
})(jQuery, window, document);

function objectifyForm(formArray) {
    //serialize data function
    var returnArray = {};
    for (var i = 0; i < formArray.length; i++) {
        returnArray[formArray[i]['name']] = formArray[i]['value'];
    }
    return returnArray;
}

function handleError(e) {
    Sentry.captureException(e);
    
    if (e && e.responseJSON && e.responseJSON.message) {
        alert(e.responseJSON.message);
    } else {
        alert('An unknown error occurred.');
    }
}
